import { render, staticRenderFns } from "./addKnowledge.vue?vue&type=template&id=78fe0c1f&lang=pug"
import script from "./addKnowledge.vue?vue&type=script&lang=js"
export * from "./addKnowledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports